import { Record } from 'immutable'

export class TransportPointState extends Record({
    id: undefined,
    order: undefined,
    name: undefined,
    rgb_bg: undefined,
    rgb_text: undefined,
}) {}
